import React from 'react';

const emi = () => (
    <div>
           
    </div>
);

export default emi;


// WEBPACK FOOTER //
// ./src/components/Payment/EMI/EMI.js